/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Negotiation_Red_Flag_No_SalaryInputs */

const en_negotiation_red_flag_no_salary = /** @type {(inputs: Negotiation_Red_Flag_No_SalaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Red flag: No salary listed`)
};

const de_negotiation_red_flag_no_salary = /** @type {(inputs: Negotiation_Red_Flag_No_SalaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Red flag: No salary listed`)
};

const fr_negotiation_red_flag_no_salary = /** @type {(inputs: Negotiation_Red_Flag_No_SalaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Red flag: No salary listed`)
};

const es_negotiation_red_flag_no_salary = /** @type {(inputs: Negotiation_Red_Flag_No_SalaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Red flag: No salary listed`)
};

const it_negotiation_red_flag_no_salary = /** @type {(inputs: Negotiation_Red_Flag_No_SalaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Red flag: No salary listed`)
};

const nl_negotiation_red_flag_no_salary = /** @type {(inputs: Negotiation_Red_Flag_No_SalaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Red flag: No salary listed`)
};

const pl_negotiation_red_flag_no_salary = /** @type {(inputs: Negotiation_Red_Flag_No_SalaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Red flag: No salary listed`)
};

const fi_negotiation_red_flag_no_salary = /** @type {(inputs: Negotiation_Red_Flag_No_SalaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Red flag: No salary listed`)
};

const da_negotiation_red_flag_no_salary = /** @type {(inputs: Negotiation_Red_Flag_No_SalaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Red flag: No salary listed`)
};

const sv_negotiation_red_flag_no_salary = /** @type {(inputs: Negotiation_Red_Flag_No_SalaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Red flag: No salary listed`)
};

/**
* | output |
* | --- |
* | "Red flag: No salary listed" |
*
* @param {Negotiation_Red_Flag_No_SalaryInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const negotiation_red_flag_no_salary = /** @type {((inputs?: Negotiation_Red_Flag_No_SalaryInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Negotiation_Red_Flag_No_SalaryInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_negotiation_red_flag_no_salary(inputs)
	if (locale === "fr") return fr_negotiation_red_flag_no_salary(inputs)
	if (locale === "es") return es_negotiation_red_flag_no_salary(inputs)
	if (locale === "it") return it_negotiation_red_flag_no_salary(inputs)
	if (locale === "nl") return nl_negotiation_red_flag_no_salary(inputs)
	if (locale === "pl") return pl_negotiation_red_flag_no_salary(inputs)
	if (locale === "fi") return fi_negotiation_red_flag_no_salary(inputs)
	if (locale === "da") return da_negotiation_red_flag_no_salary(inputs)
	if (locale === "sv") return sv_negotiation_red_flag_no_salary(inputs)
	return en_negotiation_red_flag_no_salary(inputs)
});